import React, { useLayoutEffect, useEffect, useState } from "react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

import Images from "../assets/Datas/HomeData";
import { useGlobalContext } from "../Context";
import Button from "../Components/Utils/Button";
import Carousel from "../Components/Reuseable/Carousel";
import HomeBlogCard from "../Components/Reuseable/HomeBlogCard";

export default function Home() {
  const { setNav, nav, blog } = useGlobalContext();
  const [scroll, setScroll] = useState(false);

  const scrollMeasure = () => {
    if (window.innerWidth > 800) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", scrollMeasure);

    return () => {
      window.removeEventListener("scroll", scrollMeasure);
    };
  }, []);

  useLayoutEffect(() => {
    setNav(true);
    document.title = "Beyond Limits Football Academy";
  }, [setNav, nav]);

  // console.log(nav);

  return (
    <>
      <header className="Header">
        <Carousel image={Images} />
      </header>

      {blog.length > 0 && (
        <section className="Programs">
          <div className="container">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <p className="Players__title Staff__title" style={{ margin: 0 }}>
                Beyond Limits Football Academy Latest News
              </p>
              <div style={{ display: "flex" }}>
                <Button
                  text={"view all"}
                  div={{
                    padding: "5px 20px",
                    textTransform: "capitalize",
                    backgroundColor: "#007ebb",
                    marginBottom: "2rem",
                    fontWeight: "700",
                    width: "100%",
                  }}
                  link={{
                    fontSize: "1.6rem",
                    letterSpacing: "2px",
                    color: "#fff",
                  }}
                  url={`/blog`}
                />
              </div>
            </div>
            <HomeBlogCard blog={blog} scroll={scroll}/>
          </div>
        </section>
      )}
    </>
  );
}
